/**
 * Enlaces oficiales de la app en las tiendas.
 * App Store: publicada el 20-oct-2026 (Goldia S.A.S., id6817048934).
 * Google Play: aún no publicada → la web muestra "Próximamente" mientras esté vacío.
 */
export const APP_STORE_URL = "https://apps.apple.com/co/app/gold-loterias/id6817048934";
export const PLAY_STORE_URL = "";
